import {
    Card,
    CardContent,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import type { DealRow } from '../utils/dealCalculations';

interface DealComparisonTableProps {
    rows: DealRow[];
}

const fmtDollar = (val: number): string =>
    val >= 0 ? `$${val.toLocaleString()}` : `-$${Math.abs(val).toLocaleString()}`;

export const DealComparisonTable = ({ rows }: DealComparisonTableProps) => {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Deal Comparison
                </Typography>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Deal Type</TableCell>
                                <TableCell align="right">Upfront</TableCell>
                                <TableCell align="right">Split %</TableCell>
                                <TableCell align="right">24mo Backend</TableCell>
                                <TableCell align="right">Total Value</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow key={row.label}>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        {row.label}
                                    </TableCell>
                                    <TableCell align="right">
                                        {fmtDollar(row.upfront)}
                                    </TableCell>
                                    <TableCell align="right">
                                        {row.split}%
                                    </TableCell>
                                    <TableCell align="right">
                                        {fmtDollar(row.projected24)}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                                        {fmtDollar(row.totalValue)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
};
